import { cn } from "@/lib/utils";

/**
 * Štítok „Set" — jedna položka z viacerých kovaní (KOLO 201: jeden
 * zdroj namiesto troch kópií v Cenníku, Kovaniach a výbere kovania).
 */
export function SetZnak({ className }: { className?: string }): JSX.Element {
  return (
    <span
      className={cn(
        "shrink-0 rounded-full border border-tandem-red-light bg-tandem-red-light px-1.5 py-0 text-[10px] font-medium text-primary",
        className,
      )}
      title="Set — jedna položka z viacerých kovaní, práca sa účtuje raz"
    >
      Set
    </span>
  );
}
